import React from 'react';
import { Button } from 'primereact/button';
import './gettingStarted.scss';
import StepOneImg from '../assets/images/step_1.svg';
import StepTwoImg from '../assets/images/step_2.svg';
import StepThreeImg from '../assets/images/step_3.svg';
import HelpImg from '../assets/images/need_help.png';
import VerticalLine from '../assets/images/vertical_line.png';

function BackGettingStarted() {
  return (
    <div id="container">
      <div className="flex flex-column justify-content-center ">
        <div className="steps_main_box">
          <div className="col-12 header">
            <h2>Getting Started is Easy...</h2>
          </div>
          <div className="flex justify-content-start container_box steps_section">
            <div className="flex align-items-start justify-content-center item_box">
              <div className="each-block">
                <p className="title">
                  <span className="title-number">1</span> Choose a Package
                </p>
                <ul className="category">
                  <li>UPshow quickly ships your device</li>
                  <li>Devices arrived pre-linked to your account</li>
                </ul>
              </div>
              <img className="item_img" src={StepOneImg} alt="box" />
            </div>
            <div className="flex align-items-start justify-content-center item_box">
              <div className="each-block">
                <p className="title">
                  <span className="title-number">2</span> Receive the Device
                </p>
                <ul className="category">
                  <li>No setup needed with plug-and-play technology</li>
                  <li>Works with any TV or AV System</li>
                </ul>
              </div>
              <img className="item_img" src={StepTwoImg} alt="box" />
            </div>
            <div className="flex align-items-start justify-content-center item_box">
              <div className="each-block">
                <p className="title">
                  <span className="title-number">3</span> Add Content
                </p>
                <ul className="category">
                  <li>Easily communicate with employees</li>
                  <li>Drive revenue, retention & community</li>
                </ul>
              </div>
              <img className="item_img" src={StepThreeImg} alt="box" />
            </div>
          </div>
        </div>
        <div className="flex align-items-center help_section section_light_grey">
          <div className="vertical_line absolute">
            <img className="img_line" src={VerticalLine} alt="line" />
          </div>
          <div className="col-6 text_box">
            <div>
              <h2 className="help_title">Need help?</h2>
            </div>
            <div className="help_text">
              <p>
                Want to learn more about how UPshow boosts revenue, reduces employee turnover and increases operational excellence
                to help you accomplish your business goals?
              </p>
            </div>
            <div className="help_button_text">
              <p>Click below to schedule a custom demo with an UPshow team member.</p>
            </div>
            <div>
              <Button
                className="btn-magenta"
                label="Book a demo"
                onClick={() => {
                  window.location.href = `https://www.upshow.tv/get-a-demo/`;
                }}
              />
            </div>
          </div>
          <div className="col-6">
            <img className="help_img" src={HelpImg} alt="box" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BackGettingStarted;
